/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AIGovernancePromptAnalyticsDataResponse extends models.AiGovernancePromptSummary {
    getFixupPrototypeFunction() { return AIGovernancePromptAnalyticsDataResponse.fixupPrototype; }

    static newInstance(model: Partial<AIGovernancePromptAnalyticsDataResponse>): AIGovernancePromptAnalyticsDataResponse {
        let obj = Object.assign(new AIGovernancePromptAnalyticsDataResponse(), model);
        AIGovernancePromptAnalyticsDataResponse.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AIGovernancePromptAnalyticsDataResponse>): AIGovernancePromptAnalyticsDataResponse {
        if (!model) return null;
        return AIGovernancePromptAnalyticsDataResponse.newInstance(<AIGovernancePromptAnalyticsDataResponse> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AIGovernancePromptAnalyticsDataResponse) {
        if (!obj) return;

        models.AIGovernancePromptAnalyticsDataResponse.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AIGovernancePromptAnalyticsDataResponse): boolean {
        if (models.AiGovernancePromptSummary.setPrototype(obj))
        {
            return true; // A polymorphic type, skip overwriting the prototype.
        }
        Object.setPrototypeOf(obj, AIGovernancePromptAnalyticsDataResponse.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
        super.fixupFields();
        if (this.max_tokens === undefined) {
            this.max_tokens = 0;
        }
        if (this.temperature === undefined) {
            this.temperature = 0;
        }
        if (this.top_p === undefined) {
            this.top_p = 0;
        }
        if (this.top_k === undefined) {
            this.top_k = 0;
        }
        if (this.cache_read_input_token_count === undefined) {
            this.cache_read_input_token_count = 0;
        }
        if (this.cache_write_input_token_count === undefined) {
            this.cache_write_input_token_count = 0;
        }
        if (typeof this.invoked_at === "string") {
            this.invoked_at = new Date(<string><any>this.invoked_at);
        }
        if (this.labels) {
            for (let val of this.labels) {
                models.KeyValuePair.fixupPrototype(val);
            }
        }
    }

    /**
     * Identifier of the service account that generated the prompt event
     */
    service_account_id: string;

    /**
     * Cloud region where the invocation was processed
     */
    region: string;

    /**
     * Maximum token limit configured for the request
     */
    max_tokens: number;

    /**
     * Temperature sampling value used for the request
     */
    temperature: number;

    /**
     * Top-p sampling value used for the request
     */
    top_p: number;

    /**
     * Top-k sampling value used for the request
     */
    top_k: number;

    /**
     * Number of input tokens served from cache
     */
    cache_read_input_token_count: number;

    /**
     * Number of input tokens written to cache
     */
    cache_write_input_token_count: number;

    /**
     * Timestamp when the prompt was invoked
     */
    invoked_at: Date;

    /**
     * Identity of the caller that made the invocation
     */
    requester_id: string;

    /**
     * List of tag key/value pairs
     */
    labels: Array<models.KeyValuePair>;

}
